import { Position } from "geojson";
import { PointLike } from "mapbox-gl";

import { GaiaMapMarker } from "~/modules/map/components/GaiaMapMarker";

import { AREA_MARKER_OFFSET_HOVER, AREA_MARKER_OFFSET_SELECTED } from "../map-layers/AreasLayerV2";
import { GaiaMapMarkerArea } from "./index";

type GaiaMapMarkerAreaOnMapProps = {
    plannerStatusBucket: string;
    hasStagedChanges?: boolean;
    selected?: boolean;
    coordinates: Position;
    onMouseLeave?: () => void;
    offset?: PointLike;
};

export function GaiaMapMarkerAreaOnMap({
    plannerStatusBucket,
    selected,
    hasStagedChanges,
    coordinates,
    onMouseLeave,
    offset,
}: GaiaMapMarkerAreaOnMapProps) {
    const defaultOffset = selected ? AREA_MARKER_OFFSET_SELECTED : AREA_MARKER_OFFSET_HOVER;

    return (
        <GaiaMapMarker coordinates={coordinates} onMouseLeave={onMouseLeave} offset={offset ?? defaultOffset}>
            <GaiaMapMarkerArea plannerStatusBucket={plannerStatusBucket} selected={selected} hasStagedChanges={hasStagedChanges} />
        </GaiaMapMarker>
    );
}
